export default __webpack_public_path__ + "827c8dc074b5e66a1419d532c714cefe.jpeg";